import { ChevronRight, Gift } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { Link } from "../lib/router";

/** What never costs anything, for everyone: no card needed, and it stays after the trial. */
const FREE = [
  { key: "shopping", emoji: "🛒", to: "/shopping" },
  { key: "cards", emoji: "💳", to: "/wallet" },
  { key: "places", emoji: "🏪", to: "/places" },
  { key: "board", emoji: "🏘️", to: "/board" },
  { key: "export", emoji: "📤", to: "/me" },
  { key: "support", emoji: "💬", to: "/me/support" },
] as const;

/**
 * "Free forever": the list of what stays free, said plainly, on the home page, the plans page and the landing page.
 * `links` off (the landing page, before signing in): plain lines instead of buttons.
 */
export function FreeForever({ links = true }: { links?: boolean }) {
  const { t } = useI18n();
  return (
    <section className="free-card" aria-labelledby="free-forever-title">
      <h2 id="free-forever-title">
        <Gift size={24} aria-hidden="true" /> {t("free.title")}
      </h2>
      <p>{t("free.intro")}</p>
      <ul className="free-list">
        {FREE.map((f) => {
          const inner = (
            <>
              <span className="free-emoji" aria-hidden="true">{f.emoji}</span>
              <span className="grow">
                {t(`free.${f.key}`)}
                <small>{t(`free.${f.key}Sub`)}</small>
              </span>
              {links && <ChevronRight size={20} aria-hidden="true" />}
            </>
          );
          return (
            <li key={f.key}>
              {links ? (
                <Link to={f.to}>{inner}</Link>
              ) : (
                <span className="free-item">{inner}</span>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
